import { Observable } from 'rxjs';
import { AuthenticationResponse, HealthStatus } from '../models/ApiResponse';

/**
 * Provides methods to authenticate a user.
 */
export abstract class AuthenticationService {
  /**
   * Authenticates a user given email address and password.
   *
   * @throws AuthenticationInvalidException
   * @throws PasswordResetRequiredException
   * @throws UserNotFoundException
   *
   * @param email The email address of the user.
   * @param password The password of the user.
   */
  abstract login(email: string, password: string, captchaSolution?: string): Promise<AuthenticationResponse>;

    /**
   * Authenticates a user given email address and password.
   *
   * @throws AuthenticationInvalidException
   * @throws PasswordResetRequiredException
   * @throws UserNotFoundException
   *
   * @param email The email address of the user.
   * @param password The password of the user.
   */
    abstract loginObs(email: string, password: string, captchaSolution?: string): Observable<AuthenticationResponse>;

  /**
   * Check the health status of the login. If there are multiple failed login attempts, showCaptcha = true will be returned.
   */
  abstract getHealthStatus(): Promise<HealthStatus>;

  /**
   * Logs a user out globaly.
   *
   * @param authToken Authentication Token of the user.
   * @param refreshToken Refresh Token of the user.
   * @param tenantSlug Is an optional parameter used only for SSO tenants.
   */
  abstract logout(authToken: string, refreshToken: string, tenantSlug?: string): Promise<string>;
}
